import "./LenderDashboardStyle.css";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAllOffersQuery, useAllOffersCountQuery } from "../../API/Dashboard";
import { defaultParams } from "@utils/global.constants";
import storage from "@utils/storage";
import purplesvg from "../../Assets/Images/purple-svg.png";
import greensvg from "../../Assets/Images/green-svg.png";
import yellowsvg from "../../Assets/Images/yellow-svg.png";
import lefticon from "../../Assets/Images/lefticon.svg";
import righticon from "../../Assets/Images/righticon.svg";
import { useGetWalletQuery } from "../../API/Transaction";
import envConfig from "../../environment";

type Offer = {
  offers: Offer[]
  uuid: string;
  lenderId: string;
  title: string;
  loanAmount: string;
  interestRate: string;
  loanDuration: string;
  termsAndConditions: string;
  status: string;
  isDeleted: boolean;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  applications: any[];
};

function LenderDashboard() {
  const navigate = useNavigate();
  const Id = storage.getUser();
  const userId = Id.user.userId;
  const user = Id.user
  const [params, setParams] = useState({
    ...defaultParams, status: "open"
  });

  const { isLoading, isFetching, data, isError } =
    useAllOffersQuery({
      userId,
      params,
    });

  const {
    isLoading: isCountLoading,
    isFetching: isCountFetching,
    data: offerCounts,
    refetch: refetchCounts,
    error: countError,
    isError: isCountError,
  } = useAllOffersCountQuery({
    userId,
  });
  const offerCount = offerCounts?.statusSummary;
  const latestCompletedOffer = offerCounts?.latestCompletedOffer;
  const latestUserProfileImage = latestCompletedOffer?.lender?.profileImage;
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const offers: Offer[] = data?.offers || [];
  const completedOffers = offers.filter(offer => offer.status === "completed");
  const activeOffers = offers.filter(offer => offer.status === "open");
  const approvedOffers = offers.filter(offer => offer.status === "approved");
  const filteredOffers = offers?.filter(
    (offer: Offer) => offer.status?.toLowerCase() === "open"
  );

  const {
    isLoading: isWalletLoading,
    isFetching: isWalletFetching,
    data: walletData,
    error: walletError,
    isError: isWalletError,
  } = useGetWalletQuery(userId, params);
  const walletAmount: number = walletData?.totalAmount || 0;


  const summaryData = [
    {
      label: "Completed Offers",
      count: offerCount?.completed?.count || 0,
      date: new Date().toISOString(),
      icon: purplesvg,
      path: "/app/completed-offers",
      amount: offerCount?.completed?.totalLoanAmount || 0
    },
    {
      label: "Open Offers",
      count: offerCount?.open?.count || 0,
      date: new Date().toISOString(),
      icon: greensvg,
      path: "/app/open-offers",
      amount: offerCount?.open?.totalLoanAmount || 0
    },
    {
      label: "Approved Offers",
      count: offerCount?.approved?.count || 0,
      date: new Date().toISOString(),
      icon: yellowsvg,
      path: "/app/approved-offers",
      amount: offerCount?.approved?.totalLoanAmount || 0
    },
    {
      label: "Canceled Offers",
      count: offerCount?.inActive?.count || 0,
      date: new Date().toISOString(),
      icon: yellowsvg,
      path: "/app/approved-offers",
      amount: offerCount?.inActive?.totalLoanAmount || 0
    },
  ];

  const handleSort = (key: string, order?: "ASC" | "DESC") => {
    setParams(prev => ({
      ...prev,
      sortKey: key,
      sortOrder: order ?? (prev.sortKey === key && prev.sortOrder === "DESC" ? "ASC" : "DESC"),
      page: 1,
    }));
  };

  useEffect(() => {
    if (latestUserProfileImage) {
      setProfileImage(latestUserProfileImage);
    }
  }, [latestUserProfileImage]);



  return (
    <>
      <div className="content dashboard">
        <div className="content-wrapper borrower-dashboard-section container-fluid p-0">
          <div className="row mb-4">
            <div className="col-xl-6 wall-main">
              <div className="wallet-card d-flex w-100 h-100">
                {/* <div className="lendriva-box position-relative overflow-hidden">
                  <div className="inner-box-content h-100 d-flex flex-column justify-content-between">
                    <div className="content-upper">
                      <h6 className="m-0">Lendriva</h6>
                      <p className="m-0">Lender Account</p>
                    </div>
                    <div className="content-lower">
                      <p className="m-0">Wallet Holder</p>
                      <h5 className="m-0"><span>  {user?.firstName ? user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) : "Andrew"}</span> <span> {user?.lastName ? user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1) : "Lender"}</span></h5>
                    </div>
                  </div>
                  <div className="grouped-ellipse position-absolute">
                    <img src={ellipses} alt="" className="img-fluid" />
                  </div>
                  <div className="wallet position-absolute">
                    <img src={wallet} alt="" className="img-fluid" />
                  </div>
                </div> */}
                <div className="wallet-content d-flex flex-column">
                  {/* <h2 className="m-0">£{walletAmount}</h2>
                  <p className="m-0">Wallet Balance</p> */}
                  <div className="flex-grow-1">
                    <h3 className="m-0">Smart Lending About timing.</h3>
                    <h3 className="m-0">Check out new Opportunities Bellow.</h3>
                  </div>
                  <div className="btn-wallet d-flex gap-3">
                    <button
                      onClick={() => navigate("/app/add-money")}
                      className="btn-white"
                    >
                      Add Funds
                    </button>
                    <button
                      onClick={() => navigate("/app/withdraw-money")}
                      className="btn-blue"
                    >
                      Withdraw
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="row">
                <div className="col-lg-6 application-blk-main">
                  <div className="offer-boxes h-100 create-new-offer-box position-relative overflow-hidden">
                    <div className="grouped-ellpse position-absolute">
                    </div>
                    <div className="create d-flex justify-content-between flex-column h-100 ">
                      <p className="mb-3">
                        Begin your next lending journey with ease.
                      </p>
                      <Link to="/app/create-offer">
                        <button className="create-offer-button w-100">
                          Create new offer
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-6">
                  <div className="offer-bkl h-100">
                    <Link to="/app/completed-offers" style={{ textDecoration: "none" }}>
                      <h4>Completed offer
                        <span className="ms-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_123_741)">
                              <rect width="16" height="16" transform="translate(0 16) rotate(-90)" fill="#FBFCFF" />
                              <path d="M12.5599 8.00001C12.5599 8.28676 12.4504 8.57348 12.2319 8.7921L5.35219 15.6717C4.91455 16.1094 4.205 16.1094 3.76755 15.6717C3.33009 15.2343 3.33009 14.5249 3.76755 14.0872L9.85509 8.00001L3.76776 1.91278C3.3303 1.47515 3.3303 0.765813 3.76776 0.32839C4.20522 -0.109457 4.91477 -0.109457 5.3524 0.32839L12.2321 7.20792C12.4507 7.42665 12.5599 7.71337 12.5599 8.00001Z" fill="#202224" />
                            </g>
                            <defs>
                              <clipPath id="clip0_123_741">
                                <rect width="16" height="16" fill="white" transform="translate(0 16) rotate(-90)" />
                              </clipPath>
                            </defs>
                          </svg>

                        </span>
                      </h4>
                    </Link>
                    <div className="d-flex gap-3 mb-3">
                      <div className="applicant-name-icon d-flex align-items-center justify-content-center">
                        <span className="text-capitalize">{latestCompletedOffer?.lender?.fullName?.[0] || "U"}</span>
                        <span className="text-lowercase">{latestCompletedOffer?.lender?.fullName?.split(" ")[1]?.[0] || "N"}</span>
                      </div>
                      <div>
                        <p className="name-blk">{latestCompletedOffer?.lender?.fullName.charAt(0).toUpperCase() + latestCompletedOffer?.lender?.fullName.slice(1)}</p>
                        <p className="designation-blk">{latestCompletedOffer?.title}</p>
                      </div>
                    </div>
                    <div>
                      <div className="d-flex justify-content-between gap-px">
                        <p className="title-blk">Title:</p>
                        <p className="name-title-blk">{latestCompletedOffer?.title}</p>
                      </div>
                      <div className="d-flex justify-content-between gap-px">
                        <p className="title-blk">Loan Amount:</p>
                        <p className="name-title-blk">£ {latestCompletedOffer?.loanAmount}</p>
                      </div>
                      <div className="d-flex justify-content-between gap-px">
                        <p className="title-blk">Duration:</p>
                        <p className="name-title-blk">{latestCompletedOffer?.loanDuration} Month</p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="title-blk">Loan Interest:</p>
                        <p className="name-title-blk">{latestCompletedOffer?.interestRate}%</p>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="col-lg-6">
                  <div className="offer-bkl h-100">
                    <Link to="/app/completed-offers" style={{ textDecoration: "none" }}>
                      <h4>
                        Completed offer
                        <span className="ms-2">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_123_741)">
                              <rect width="16" height="16" transform="translate(0 16) rotate(-90)" fill="#FBFCFF" />
                              <path d="M12.5599 8.00001C12.5599 8.28676 12.4504 8.57348 12.2319 8.7921L5.35219 15.6717C4.91455 16.1094 4.205 16.1094 3.76755 15.6717C3.33009 15.2343 3.33009 14.5249 3.76755 14.0872L9.85509 8.00001L3.76776 1.91278C3.3303 1.47515 3.3303 0.765813 3.76776 0.32839C4.20522 -0.109457 4.91477 -0.109457 5.3524 0.32839L12.2321 7.20792C12.4507 7.42665 12.5599 7.71337 12.5599 8.00001Z" fill="#202224" />
                            </g>
                            <defs>
                              <clipPath id="clip0_123_741">
                                <rect width="16" height="16" fill="white" transform="translate(0 16) rotate(-90)" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </h4>
                    </Link>

                    {latestCompletedOffer ? (
                      <>
                        <div className="d-flex gap-3 mb-3">
                          {profileImage ? (
                            <img
                              src={`${envConfig.photoUrl}/public/profileImage/${profileImage}`}
                              alt="Profile"
                              className="name-initials-box rounded-full object-cover w-full h-full"
                            />
                          ) : (
                            <div className="applicant-name-icon d-flex align-items-center justify-content-center">
                              <span className="text-capitalize">{latestCompletedOffer?.lender?.fullName?.[0] || "U"}</span>
                              <span className="text-lowercase">{latestCompletedOffer?.lender?.fullName?.split(" ")[1]?.[0] || "N"}</span>
                            </div>
                          )}
                          {/* <div className="applicant-name-icon d-flex align-items-center justify-content-center">
                            <span className="text-capitalize">{latestCompletedOffer?.lender?.fullName?.[0] || "U"}</span>
                            <span className="text-lowercase">{latestCompletedOffer?.lender?.fullName?.split(" ")[1]?.[0] || "N"}</span>
                          </div> */}
                          <div>
                            <p className="name-blk">
                              {latestCompletedOffer?.lender?.fullName?.charAt(0).toUpperCase() +
                                latestCompletedOffer?.lender?.fullName?.slice(1)}
                            </p>
                            <p className="designation-blk">{latestCompletedOffer?.title}</p>
                          </div>
                        </div>

                        <div>
                          <div className="d-flex justify-content-between gap-px">
                            <p className="title-blk">Title:</p>
                            <p className="name-title-blk">{latestCompletedOffer?.title}</p>
                          </div>
                          <div className="d-flex justify-content-between gap-px">
                            <p className="title-blk">Loan Amount:</p>
                            <p className="name-title-blk">£ {latestCompletedOffer?.loanAmount}</p>
                          </div>
                          <div className="d-flex justify-content-between gap-px">
                            <p className="title-blk">Duration:</p>
                            <p className="name-title-blk">{latestCompletedOffer?.loanDuration} Month</p>
                          </div>
                          <div className="d-flex justify-content-between">
                            <p className="title-blk">Loan Interest:</p>
                            <p className="name-title-blk">{latestCompletedOffer?.interestRate}%</p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center py-4">
                        <p>No completed offer found.</p>
                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="row db-row m-0">
            {summaryData.map((item, index) => {
              const isLast = index === summaryData.length - 1;
              return (
                <div className="col-lg-3 mb-2" key={index} onClick={() => navigate(item.path)}
                  style={{ cursor: "pointer" }}>
                  <div
                    className={`offer-boxes h-100 ${isLast ? "border-left-last" : ""}`}
                  >
                    <div className="offer-inner-wrapper d-flex flex-column justify-content-between h-100">
                      <div className="offer-upper-infobox">
                        <p className="m-0" dangerouslySetInnerHTML={{ __html: item.label.replace(' ', ' ') }} />
                        <h6 className="m-0">{item.count}</h6>
                      </div>
                      <div className="offer-lower-infobox">
                        {/* <div className="svg-db">
                            <img src={item.icon} alt="" className="img-fluid" />
                          </div> */}
                        <h6 className="m-0">£{item.amount}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}



          </div>

          <div className="outer-box-wrapper">
            <div className="d-flex justify-content-between align-items-center title-dropdown-box">
              <h5 className="heading m-0">New Offers with New Applications</h5>
            </div>
            <div className="table-section rounded-3 overflow-auto mt-4">
              <div className="table-responsive">
                <table className="table align-middle">
                  <thead className="table-light">
                    <tr>
                      <th >Title</th>
                      <th >Loan Amount</th>
                      <th >Interest Rate</th>
                      <th >Loan Duration</th>
                      <th onClick={() => handleSort("createdAt")}>Offer Date</th>
                      <th>No. of applications</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading || isFetching ? (
                      <tr>
                        <td colSpan={8} className="text-center py-4">Loading...</td>
                      </tr>
                    ) : isError ? (
                      <tr>
                        <td colSpan={8} className="text-center text-danger py-4">Error loading offers.</td>
                      </tr>
                    ) : filteredOffers?.length ? (
                      filteredOffers.map((offer: Offer, index: number) => (
                        <tr key={offer.uuid || index}>
                          <td>{offer.title}</td>
                          <td>£{Number(offer.loanAmount).toLocaleString()}</td>
                          <td>{offer.interestRate}%</td>
                          <td>{offer.loanDuration} months</td>
                          <td>
                            {new Intl.DateTimeFormat("en-US", {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }).format(new Date(offer.createdAt))}
                          </td>
                          <td>{String(offer.applications.length).padStart(1, '0')}</td>
                          <td>
                            <div className="action-icons d-flex">
                              <a className="view" onClick={() => navigate("/app/offer-applications", { state: { offerId: offer.uuid } })}>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M23.8474 11.5331C23.633 11.2398 18.5244 4.35156 11.9999 4.35156C5.47528 4.35156 0.366464 11.2398 0.152292 11.5328C0.0533293 11.6684 0 11.8319 0 11.9998C0 12.1676 0.0533293 12.3311 0.152292 12.4667C0.366464 12.76 5.47528 19.6482 11.9999 19.6482C18.5244 19.6482 23.633 12.76 23.8474 12.4669C23.9465 12.3314 23.9999 12.1679 23.9999 12C23.9999 11.8321 23.9465 11.6686 23.8474 11.5331ZM11.9999 18.0658C7.19381 18.0658 3.03126 13.494 1.79906 11.9994C3.02967 10.5034 7.18349 5.93397 11.9999 5.93397C16.8057 5.93397 20.9679 10.505 22.2007 12.0004C20.97 13.4963 16.8162 18.0658 11.9999 18.0658Z"
                                    fill="#2C3E50"
                                  />
                                  <path
                                    d="M12.0002 7.25244C9.3826 7.25244 7.25293 9.38211 7.25293 11.9997C7.25293 14.6173 9.3826 16.747 12.0002 16.747C14.6178 16.747 16.7475 14.6173 16.7475 11.9997C16.7475 9.38211 14.6178 7.25244 12.0002 7.25244ZM12.0002 15.1645C10.255 15.1645 8.83538 13.7448 8.83538 11.9997C8.83538 10.2546 10.2551 8.83489 12.0002 8.83489C13.7453 8.83489 15.165 10.2546 15.165 11.9997C15.165 13.7448 13.7454 15.1645 12.0002 15.1645Z"
                                    fill="#2C3E50"
                                  />
                                </svg>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} className="text-center py-4">No offers found.</td>
                      </tr>
                    )}
                  </tbody>


                </table>

              </div>
              <div className="pagination justify-content-end">
                {data?.totalOffers > 0 && (
                  <div className="d-flex justify-content-end align-items-center mt-3 next-prev-btns mb-3">
                    <div>
                      {(() => {
                        const startItem = (data.currentPage - 1) * params.pageSize + 1;
                        const endItem = Math.min(startItem + params.pageSize - 1, data.totalOffers);
                        return `${startItem}-${endItem} of ${data.totalOffers}`;
                      })()}
                    </div>

                    <div className="d-flex pagination-button gap-2">
                      <button
                        className="btn btn-outline-secondary p-0 previous-btn-lender"
                        disabled={data.currentPage === 1}
                        onClick={() =>
                          setParams(prev => ({
                            ...prev,
                            page: prev.page - 1,
                          }))
                        }
                      >
                        <img src={lefticon} alt="" />

                      </button>

                      <button
                        className="btn btn-outline-secondary p-0 next-btn"
                        disabled={data.currentPage >= data.totalPages}
                        onClick={() =>
                          setParams(prev => ({
                            ...prev,
                            page: prev.page + 1,
                          }))
                        }
                      >
                        {/* <img src={righticon} alt="" /> */}
                        <img src={righticon} alt="" className="" />

                      </button>
                    </div>
                  </div>
                )}

              </div>
            </div>

          </div>
        </div>
      </div >
    </>
  );
}

export default LenderDashboard;
